import { defineConfig, createSystem, defaultConfig } from '@chakra-ui/react'

const config = defineConfig({
  globalCss: {
    html: {
      colorPalette: "brand", // Change this to any color palette you prefer
    },
  },
  theme: {
    tokens: {
      colors: {
        brand: {
          100: { value: "#e8f6f4" },
        },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          solid: { value: "#01A086" },
          contrast: { value: "#FFFFFF" },
          fg: { value: "#000000" },
          muted: { value: "#BDE5DF" }, //#6CC7B7
          // subtle: { value: "#BDE5DF" }, //#57B4A4
          subtle: { value: "#BDE5DF" }, //#57B4A4
          emphasized: { value: "#41A392" },
          focusRing: { value: "#01A086" },
        },
      },
    },
  },
})

export const system = createSystem(defaultConfig, config)